import * as z from "zod";

export const enableDisputesBilling = {
  name: "enableDisputesBilling" as const,
  input: z.object({
    /** Shopify charge-approval return path; validated against the permissions
     * next-path allowlist. Defaults to the disputes dashboard. */
    returnPath: z.string().optional(),
  }),
  output: z.object({
    status: z.enum([
      "billing_already_enabled",
      "billing_enabled",
      "shopify_confirmation_required",
    ]),
    confirmationUrl: z.string().optional(),
  }),
};
